import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "try-wrapper"
};
const _hoisted_2 = {
  class: "try-svip"
};
const _hoisted_3 = {
  class: "try-svip__left"
};
const _hoisted_4 = {
  class: "try-svip__progress"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "try-svip__center"
};
const _hoisted_8 = {
  class: "try-svip__primary"
};
const _hoisted_9 = {
  key: 0,
  class: "try-svip__secondary"
};
const _hoisted_10 = {
  key: 1,
  class: "try-svip__secondary"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "try-svip__right"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "qh-icon-close"
}, null, -1);
const _hoisted_15 = [_hoisted_14];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TdProgress = _resolveComponent("TdProgress");
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_ctx.statusRef === 'BEFORE_TRY' ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "try-svip__speed--before",
    src: _ctx.speedIcon,
    draggable: "false"
  }, null, 8, _hoisted_5)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createVNode(_component_TdProgress, {
    type: "circle",
    color: "#F1C37B",
    "outer-color": "#D5D9DE",
    linecap: "square",
    value: _ctx.statusRef === 'TRYING' ? _ctx.tryTimeUsagePercentage : 100,
    width: 32,
    "text-visible": false,
    "stroke-width": 2
  }, null, 8, ["value"]), _createElementVNode("img", {
    class: "try-svip__speed",
    src: _ctx.speedIcon,
    draggable: "false"
  }, null, 8, _hoisted_6)], 64))])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.primaryTitleRef), 1), _ctx.statusRef !== 'TRYING' ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.secondaryTitleRef), 1)) : _createCommentVNode("", true), _ctx.statusRef === 'TRYING' && (_ctx.teamTaskIDListRef.length > 0 || _ctx.superSpeedTaskIDListRef.length > 0) ? (_openBlock(), _createElementBlock("span", _hoisted_10, [_createVNode(_component_swiper, {
    class: "swiper",
    direction: "vertical",
    autoplay: {
      delay: 3000
    },
    loop: "",
    modules: _ctx.modules
  }, {
    default: _withCtx(() => [_ctx.teamTaskIDListRef.length > 0 ? (_openBlock(), _createBlock(_component_swiper_slide, {
      key: 0
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: _ctx.isNewVipPrivilege ? _ctx.teamIcon : _ctx.oldTeamIcon,
        draggable: "false"
      }, null, 8, _hoisted_11), _createTextVNode(" " + _toDisplayString(_ctx.isNewVipPrivilege ? '超级通道' : '组队加速') + "任务: " + _toDisplayString(_ctx.teamTaskIDListRef.length), 1)]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.superSpeedTaskIDListRef.length > 0 ? (_openBlock(), _createBlock(_component_swiper_slide, {
      key: 1
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: _ctx.isNewVipPrivilege ? _ctx.tryingIcon : _ctx.oldTryingIcon,
        draggable: "false"
      }, null, 8, _hoisted_12), _createTextVNode(" " + _toDisplayString(_ctx.isNewVipPrivilege ? '会员加速' : '超级加速') + " 任务: " + _toDisplayString(_ctx.superSpeedTaskIDListRef.length), 1)]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modules"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [!(_ctx.statusRef !== 'BEFORE_TRY' && _ctx.platformPath === 'hik') ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "try-svip__open",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.onClick && _ctx.onClick(...args))
  }, _toDisplayString(_ctx.buttonTextRef), 1)) : _createCommentVNode("", true), _createElementVNode("a", {
    class: "try-svip__close",
    href: "javascript:;",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.closeBanner && _ctx.closeBanner(...args)),
    style: _normalizeStyle({
      display: _ctx.statusRef === 'TRYING' ? 'none' : 'block'
    })
  }, _hoisted_15, 4)])])], 512)), [[_vShow, _ctx.isBannerVisibleRef]]);
}